"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const spaces_1 = require("@/common/boards/spaces");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'GoToMap',
    props: {
        playerinput: {
            type: Object,
            required: true,
        },
    },
    methods: {
        onclick(event) {
            event.preventDefault();
            const id = (0, spaces_1.isMarsSpace)(this.playerinput.spaces?.[0] ?? '00') ? 'shortkey-board' : 'shortkey-moonBoard';
            document.dispatchEvent(new CustomEvent('tm-goto-board'));
            this.$nextTick(() => {
                const el = document.getElementById(id);
                el?.scrollIntoView({ block: 'center', inline: 'center', behavior: 'auto' });
            });
        },
    },
});
